var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhlLogoLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 12,
    viewBox: "0 0 86 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.286 5c.751 0 .742.268.374.736-.373.476-1.008 1.292-1.388 1.775-.193.245-.542.691.614.691H32C31.242 9.178 28.783 12 24.369 12H11l5.482-7h6.804zM43 8l-3.024 4H32s3.022-4 3.025-4H43zm-32 3-.666 1H0v-1h11zm43-3-3.025 4H43s3.023-4 3.025-4H54zm21 0-2.967 4H59.474c-3.206 0-4.074-1.535-3.092-2.852.278-.372.85-1.148.85-1.148H75zm10 3v.999L73 12l.594-1H85zM12 8l-.596 1H11l-.6 1H0V8h12zm73 1v1H74l.603-1H85zm1-1v1H75l.671-1H86zM30.636 0c4.034 0 5.064 3.102 3.936 4.593l-.22.29-.221.293L32.753 7h-6.137c-1.166 0-.814-.467-.62-.722.384-.505 1.014-1.369 1.39-1.865.371-.49.381-.77-.377-.77H12L14.754 0h15.882zM71 0l-5.03 7H58s5.032-7 5.035-7H71zM48.394 0l-3.077 4.014h3.58L51.978 0H60l-5.367 7H35l5.369-7h8.025z",
    fill: "#E30017",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogoLabel);
export default __webpack_public_path__ + "static/media/dhl_logo_label.0bcf466d2ea667b1678705a42c52c29d.svg";
export { ForwardRef as ReactComponent };